<div class="xf-content-height pb-5">
    <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
        <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
            <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
                <div class="parsys aem-GridColumn aem-GridColumn--default--12">
                    <div class="richtext parbase section ada-focus"><p>
                        <h1 style="text-align: center;"><span class="rte-font-size-24 faq-heading ada-focus">{{properties.partnersBanners.FAQ}}</span>
                        </h1>
                    </div>
                    <div class="accordion-container section">
                        <div class="container accordion-container-v2" style="width:inherit">
                            <h2 class="accordion-container-title display-6"></h2>
                            <div class="accordion-container page-content display-type" data-display-type="expandFirst">
                                <div *ngFor="let faq of faqData" class="accordion-item parbase section ada-focus">
                                    <h2 role="button" tabindex="0" class="faq-accordion-header accordion-header chevron body-l body-l--bold ada-focus">
                                        <b>{{faq.question}}</b></h2>
                                    <div class="faq-accordion-content accordion-content ada-focus">
                                        <p class="shortentext ada-focus">
                                            {{faq.response}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
